import { combineComponents } from "~utils";

import { BoardLocalPersistenceProvider } from "./board";
import { BoardTypeLocalPersistenceProvider } from "./board-type";
import { CustomPlayersLocalPersistenceProvider } from "./custom-players";
import { FormationLocalPersistenceProvider } from "./formation";
import { PreferencesLocalPersistenceProvider } from "./preferences";

export const LocalForageProvider = combineComponents(
  BoardLocalPersistenceProvider,
  BoardTypeLocalPersistenceProvider,
  CustomPlayersLocalPersistenceProvider,
  FormationLocalPersistenceProvider,
  PreferencesLocalPersistenceProvider,
);
